export default __webpack_public_path__ + "static/media/pie_chart_white.38f91e89.svg";